export const itMessages = {
    "grid": {
        "groupPanelEmpty": "Trascina una intestazione qui per raggruppare per la colonna scelta",
        "pagerItemsPerPage": "elementi per pagina",
        "pagerInfo": "{0} - {1} di {2} elementi",
        "pagerFirstPage": "vai alla prima pagina",
        "pagerPreviousPage": "pagina prcedente",
        "pagerNextPage": "pagina successiva",
        "pagerLastPage": "ultima pagina",
        "pagerPage": "Pagina",
        "pagerOf": "di",
        "filterClearButton": "Ripulisci",
        "filterEqOperator": "Uguale a",
        "filterNotEqOperator": "Diverso da",
        "filterIsNullOperator": "Nullo",
        "filterIsNotNullOperator": "Non nullo",
        "filterIsEmptyOperator": "Vuoto",
        "filterIsNotEmptyOperator": "Non vuoto",
        "filterStartsWithOperator": "Inizia con",
        "filterContainsOperator": "Contiene",
        "filterNotContainsOperator": "Non contiene",
        "filterEndsWithOperator": "Finisce con",
        "filterGteOperator": "Maggiore o uguale di",
        "filterGtOperator": "Maggiore di",
        "filterLteOperator": "Minore o uguale di",
        "filterLtOperator": "Minore di",
        "filterIsTrue": "Vero",
        "filterIsFalse": "Falso",
        "filterBooleanAll": "(Tutti)",
        "filterAfterOrEqualOperator": "Successivo o uguale a",
        "filterAfterOperator": "Si trova dopo",
        "filterBeforeOperator": "Si trova prima",
        "filterBeforeOrEqualOperator": "Si trova prima o uguale a",
        "noRecords": "Nessun record disponibile.",
        "filterAriaLabel": "Filtro",
        "filterCheckAll": "Seleziona tutto",
        "filterChooseOperator": "Scegli operatore",
        "filterSelectedItems": "oggetti selezionati",
        "filterSubmitButton": "Filtro",
        "filterTitle": "Filtro",
        "filterAndLogic": "e",
        "filterOrLogic": "o",
        "groupColumn": "Colonna gruppo",
        "pagerTotalPages": "{0}",
        "searchPlaceholder": "Ricerca",
        "sortAriaLabel": "Ordinabile",
        "sortAscending": "Ordine crescente",
        "sortDescending": "Ordine decrescente",
        "ungroupColumn": "Separa colonna"
    },
    "filter": {
        "eqOperator": "Uguale a",
        "notEqOperator": "Diverso da",
        "isNullOperator": "Nullo",
        "isNotNullOperator": "Non nullo",
        "isEmptyOperator": "Vuoto",
        "isNotEmptyOperator": "Non vuoto",
        "startsWithOperator": "Inizia con",
        "containsOperator": "Contiene",
        "notContainsOperator": "Non contiene",
        "endsWithOperator": "Finisce con",
        "gteOperator": "Maggiore o uguale di",
        "gtOperator": "Maggiore di",
        "lteOperator": "Minore o uguale di",
        "ltOperator": "Minore di",
        "isTrue": "Vero",
        "isFalse": "Falso",
        "afterOrEqualOperator": "Si trova dopo o uguale a",
        "afterOperator": "Si trova dopo",
        "beforeOperator": "Si trova prima",
        "beforeOrEqualOperator": "Is before or equal to",
        "andLogic": "E",
        "orLogic": "Oppure",
        "addExpression": "Aggiungi Espressione",
        "addGroup": "Aggiungi Gruppo",
        "close": "Chiudi",
        "filterAriaLabel": "Filtro"
    },
    "dateinput": {
        "increment": "Aumenta valore",
        "decrement": "Diminuisci valore"
    },
    "calendar": {
        "today": "OGGI"
    },
    "datepicker": {
        "toggleCalendar": "Attiva o Disattiva Calendario"
    },
    "daterangepicker": {
        "swapStartEnd": "Scambia i valori di inizio e fine",
        "start": "Inizio",
        "end": "Fine",
        "separator": " "
    },
    "datetimepicker": {
        "date": "Data",
        "time": "Tempo",
        "toggleDateTimeSelector": "Attiva o disattiva il selettore data e ora",
        "cancel": "Annulla",
        "set": "Imposta"
    },
    "editor": {
        "bold": "Grassetto",
        "italic": "Corsivo",
        "underline": "Sottolineato",
        "strikethrough": "Barrato",
        "subscript": "Deponente",
        "superscript": "Indice",
        "unlink": "Rimuovi collegamento",
        "undo": "Annulla operazione",
        "redo": "Ripeti operazione",
        "fontSize": "Grandezza Font",
        "fontName": "Nome Font",
        "format": "Formato",
        "alignLeft": "Allinea testo a sinistra",
        "alignRight": "Allinea testo a destra",
        "alignCenter": "Centra il testo",
        "alignJustify": "Giustifica",
        "indent": "Indenta",
        "outdent": "Outdenta",
        "orderedList": "Inserisci lista ordinata",
        "bulletList": "Inserisci lista non ordinata",
        "createTable": "Crea tabella",
        "insertTableHint": "Crea a {0} x {1} tabella",
        "addRowBefore": "Aggiungi riga sopra",
        "addRowAfter": "Aggiungi riga sotto",
        "addColumnBefore": "Aggiungi colonna a sinistra",
        "addColumnAfter": "Aggiungi colonna a desctra",
        "deleteRow": "Elimina riga",
        "deleteColumn": "Elimina Colonna",
        "deleteTable": "Elimina tabella",
        "mergeCells": "Unisci celle",
        "splitCell": "Dividi celle",
        "hyperlink": "Inserisci collegamento",
        "hyperlink-dialog-title": "Inserisci collegamento",
        "hyperlink-dialog-content-address": "Indirizzo web",
        "hyperlink-dialog-content-title": "Titolo",
        "hyperlink-dialog-content-newwindow": "Apri il oink in una nuova finestra",
        "hyperlink-dialog-cancel": "Annulla",
        "hyperlink-dialog-insert": "Inserisci",
        "image": "Inserisci immagine",
        "image-dialog-title": "Inserisci immagine",
        "image-address": "Indirizzo web",
        "image-title": "Titolo",
        "image-altText": "Testo alternativo",
        "image-width": "Ampiezza (px)",
        "image-height": "Altezza (px)",
        "image-cancel": "Annulla",
        "image-insert": "Inserisci",
        "viewHtml": "Vista HTML",
        "viewHtml-dialog-title": "Vista HTML",
        "viewHtml-cancel": "Annulla",
        "viewHtml-update": "Aggiorna",
        "print": "Stampa",
        "selectAll": "Seleziona tutto",
        "cleanFormatting": "Formattazione pulita",
        "pdf": "Esporta come PDF",
        "foregroundColor": "Colore",
        "backgroundColor": "Colore di sfondo",
        "insertFile": "Inserisci file",
        "insertFileDialogTitle": "Inserisci file",
        "insertFileAddress": "indirizzo Web",
        "insertFileTitle": "Titolo",
        "insertFileCancel": "Annulla",
        "insertFileInsert": "Inserire",
        "findReplaceToolTitle": "Trova e sostituisci",
        "findReplaceDialogTitle": "Trova e sostituisci",
        "findReplaceTabFind": "Trovare",
        "findReplaceTabReplace": "Sostituire",
        "findReplaceFindWhat": "Trovare cosa:",
        "findReplaceReplaceWith": "Sostituirlo con",
        "findReplaceReplace": "Sostituire",
        "findReplaceReplaceAll": "Sostituisci tutto",
        "findReplaceMatchCase": "Fiammifero",
        "findReplaceMatchWord": "Abbina solo parole intere",
        "findReplaceMatchCyclic": "Partita ciclica (avvolgi)",
        "findReplaceUseRegExp": "Espressione regolare",
        "findReplacePrevMatch": "Precedente",
        "findReplaceNextMatch": "Prossimo",
        "findReplaceMatches": "{0} di {1} corrispondenze"
    },
    "timepicker": {
        "now": "ORA CORRENTE",
        "selectNow": "Seleziona ora correnete",
        "cancel": "Annulla",
        "set": "Imposta",
        "toggleTimeSelector": "Attiva o disattiva selettore del tempo",
        "toggleClock": "Attiva o disattiva Orologio"
    },
    "dropdowns": {
        "nodata": "NESSUN DATO TROVATO.",
        "clear": "Ripulisci"
    },
    "numerictextbox": {
        "increment": "Aumenta valore",
        "decrement": "Diminuisci valore"
    },
    "upload": {
        "cancel": "Annulla",
        "clearSelectedFiles": "Ripulisci",
        "dropFilesHere": "Trascina i files qui per caricarli",
        "headerStatusUploaded": "Fatto",
        "headerStatusUploading": "Caricamento...",
        "invalidFileExtension": "Il tipo di file non è consentito.",
        "invalidFiles": "File non valido(i). Controlla i requisiti per il carimaneto dei file.",
        "invalidMaxFileSize": "La dimensione del File è troppo grande.",
        "invalidMinFileSize": "La dimensione del File è troppo piccola.",
        "remove": "Rimuovi",
        "retry": "Riprova",
        "select": "Seleziona i files...",
        "uploadSelectedFiles": "Carica",
        "total": "Totale",
        "files": "files",
        "dropZoneHint": "Trascina e rilascia i file qui per caricarli.",
        "dropZoneNote": "Sono consentiti solo file JPEG e PNG.",
        "statusUploadFailed": "Impossibile caricare i file.",
        "statusUploaded": "File caricati con successo."
    },
    "sortable": {
        "noData": "Nessun dato"
    },
    "pager": {
        "itemsPerPage": "Elementi per pagina",
        "info": "{0} - {1} di {2} elementi",
        "firstPage": "Vai alla prima pagina",
        "previousPage": "Vai alla paina precedente",
        "nextPage": "Vai alla pagina successiva",
        "lastPage": "Vai Ultima pagina",
        "page": "Pagina",
        "of": "di",
        "pagerTotalPages": "{0}"
    },
    "treelist": {
        "filterClearButton": "Ripulisci",
        "filterEqOperator": "Uguale a",
        "filterNotEqOperator": "Diverso da",
        "filterIsNullOperator": "Nullo",
        "filterIsNotNullOperator": "Nono nullo",
        "filterIsEmptyOperator": "Vuoti",
        "filterIsNotEmptyOperator": "Nono vuoto",
        "filterStartsWithOperator": "Inizia con",
        "filterContainsOperator": "Contiene",
        "filterNotContainsOperator": "Non contiene",
        "filterEndsWithOperator": "Finisce con",
        "filterGteOperator": "Maggiore o uguale di",
        "filterGtOperator": "Maggiore di",
        "filterLteOperator": "Minore o uguale di",
        "filterLtOperator": "Minore di",
        "filterIsTrue": "Vero",
        "filterIsFalse": "False",
        "filterBooleanAll": "(Tutti)",
        "filterAfterOrEqualOperator": "Si trova dopo o uguale a",
        "filterAfterOperator": "Si trova dopo",
        "filterBeforeOperator": "Si trova prima",
        "filterBeforeOrEqualOperator": "Si trova prima o uguale a",
        "noRecords": "Nessun record disponibile"
    },
    "scheduler": {
        "editorValidationRequired": "Il campo è obbligatiorio.",
        "editorValidationStart": "L'ora di inizio deve essere precedente all'ora di fine.",
        "editorValidationEnd": "L'ora di fine deve essere successiva all'ora di inizio.",
        "allEvents": "Tutti gli eventi",
        "allDay": "tutto il giorno",
        "today": "Oggi",
        "dayViewTitle": "Giorno",
        "monthViewTitle": "Mese",
        "weekViewTitle": "Settimana",
        "workWeekViewTitle": "Settimana di lavoro",
        "timelineViewTitle": "Sequenza temporale",
        "agendaViewTitle": "Ordine del giorno",
        "deleteTitle": "Eliminare",
        "previousTitle": "Precedente",
        "nextTitle": "Prossimo",
        "showFullDay": "Mostra intera giornata",
        "showWorkDay": "Mostra l'orario di lavoro",
        "editOccurrence": "Modifica occorrenza corrente",
        "editorSeries": "Modifica la serie",
        "editorRecurringConfirmation": "Vuoi modificare solo questa occorrenza dell'evento o l'intera serie?",
        "editorRecurringDialogTitle": "Modifica elemento ricorrente",
        "editorSave": "Salva",
        "editorCancel": "Annulla",
        "editorDelete": "Eliminare",
        "editorTitle": "Evento",
        "editorEventTitle": "Titolo",
        "editorEventStart": "Inizio",
        "editorEventStartTimeZone": "Fuso orario iniziale",
        "editorEventEnd": "Fine",
        "editorEventEndTimeZone": "Fine fuso orario",
        "editorEventAllDay": "Evento tutto il giorno",
        "editorEventDescription": "Descrizione",
        "editorEventSeparateTimeZones": "Fine in un fuso orario diverso",
        "editorEventTimeZone": "Specifica fuso orario",
        "recurrenceEditorRepeat": "Ripetere",
        "recurrenceEditorDailyInterval": "giorno/i",
        "recurrenceEditorDailyRepeatEvery": "Ripeti ogni",
        "recurrenceEditorWeeklyInterval": "settimana/e",
        "recurrenceEditorWeeklyRepeatEvery": "Ripeti ogni",
        "recurrenceEditorWeeklyRepeatOn": "Ripeti su",
        "recurrenceEditorMonthlyDay": "Giorno",
        "recurrenceEditorMonthlyInterval": "mesi)",
        "recurrenceEditorMonthlyRepeatEvery": "Ripeti ogni",
        "recurrenceEditorMonthlyRepeatOn": "Ripeti su",
        "recurrenceEditorYearlyOf": "di",
        "recurrenceEditorYearlyRepeatEvery": "Ripeti ogni",
        "recurrenceEditorYearlyRepeatOn": "Ripeti su",
        "recurrenceEditorYearlyInterval": "anni)",
        "recurrenceEditorFrequenciesDaily": "Quotidiano",
        "recurrenceEditorFrequenciesMonthly": "Mensile",
        "recurrenceEditorFrequenciesNever": "Mai",
        "recurrenceEditorFrequenciesWeekly": "settimanalmente",
        "recurrenceEditorFrequenciesYearly": "Annuale",
        "recurrenceEditorOffsetPositionsFirst": "Primo",
        "recurrenceEditorOffsetPositionsSecond": "Secondo",
        "recurrenceEditorOffsetPositionsThird": "Terzo",
        "recurrenceEditorOffsetPositionsFourth": "Il quarto",
        "recurrenceEditorOffsetPositionsLast": "Scorso",
        "recurrenceEditorWeekdaysDay": "Giorno",
        "recurrenceEditorWeekdaysWeekday": "giorno della settimana",
        "recurrenceEditorWeekdaysWeekendday": "Giorno del fine settimana",
        "recurrenceEditorEndAfter": "A seguito di",
        "recurrenceEditorEndOccurrence": "occorrenza(e)",
        "recurrenceEditorEndLabel": "Fine",
        "recurrenceEditorEndNever": "Mai",
        "recurrenceEditorEndOn": "Sopra",
        "deleteConfirmation": "sei sicuro di voler cancellare questo evento?",
        "deleteRecurringConfirmation": "Vuoi eliminare solo questa occorrenza dell'evento o l'intera serie?",
        "deleteOccurrence": "Elimina occorrenza corrente",
        "deleteSeries": "Elimina la serie",
        "deleteDialogTitle": "Elimina evento",
        "deleteRecurringDialogTitle": "Elimina elemento ricorrente",
        "dateTitle": "Data",
        "timeTitle": "Volta",
        "eventTitle": "Evento",
        "noEvents": "nessun evento"
    },
    "listbox": {
        "moveUp": "Andare avanti",
        "moveDown": "Abbassati",
        "transferTo": "Trasferire a",
        "transferFrom": "Trasferito da",
        "transferAllTo": "Trasferisci tutto a",
        "transferAllFrom": "Trasferisci tutto da",
        "remove": "Eliminare"
    },
    "stepper": {
        "optionalText": "(Opzionale)"
    },
    "labels": {
        "labelsOptional": "(Opzionale)"
    },
    "slider": {
        "increment": "Aumento",
        "decrement": "Diminuire",
        "dragTitle": "Trascinare"
    },
    "colorGradient": {
        "r": "R",
        "g": "G",
        "b": "B",
        "a": "un",
        "hex": "esadecimale",
        "contrastRatio": "Rapporto di contrasto",
        "colorGradientAALevel": "aa",
        "colorGradientAAALevel": "AAA",
        "colorGradientPass": "Passaggio",
        "colorGradientFail": "Fallire"
    },
    "checkbox": {
        "validation": "Seleziona questa casella se vuoi procedere!",
        "optionalText": "(Opzionale)"
    },
    "radioButton": {
        "validation": "Si prega di selezionare l'opzione se si desidera procedere!"
    },
    "switch": {
        "validation": "Per favore accendi se vuoi procedere!"
    },
    "gantt": {
        "weekViewTitle": "Settimana",
        "dayViewTitle": "Giorno",
        "monthViewTitle": "Mese",
        "yearViewTitle": "Anno",
        "filterClearButton": "Chiaro",
        "filterEqOperator": "È uguale a",
        "filterNotEqOperator": "Non è uguale a",
        "filterIsNullOperator": "È zero",
        "filterIsNotNullOperator": "non è nullo",
        "filterIsEmptyOperator": "È vuoto",
        "filterIsNotEmptyOperator": "Non è vuoto",
        "filterStartsWithOperator": "Inizia con",
        "filterContainsOperator": "contiene",
        "filterNotContainsOperator": "Non contiene",
        "filterEndsWithOperator": "Finisce con",
        "filterGteOperator": "È più grande di O uguale a",
        "filterGtOperator": "È più grande di",
        "filterLteOperator": "È minore o uguale a",
        "filterLtOperator": "È meno di",
        "filterIsTrue": "È vero",
        "filterIsFalse": "È falso",
        "filterBooleanAll": "(Tutto)",
        "filterAfterOrEqualOperator": "È dopo o uguale a",
        "filterAfterOperator": "è dopo",
        "filterBeforeOperator": "è prima",
        "filterBeforeOrEqualOperator": "È prima o uguale a",
        "noRecords": "Nessun record disponibile",
        "editorSave": "Salva",
        "editorCancel": "Annulla",
        "editorTitle": "Compito",
        "editorTaskTitle": "Titolo",
        "editorTaskStart": "Inizio",
        "editorTaskEnd": "Fine",
        "editorTaskComplete": "Completare",
        "editorValidationRequired": "Il campo è obbligatiorio.",
        "editorValidationStart": "L'ora di inizio deve essere precedente all'ora di fine.",
        "editorValidationEnd": "L'ora di fine deve essere successiva all'ora di inizio.",
        "addTask": "Aggiungi attività",
        "addChild": "Aggiungi bambino",
        "addAbove": "Aggiungi sopra",
        "addBelow": "Aggiungi sotto",
        "editorDelete": "Eliminare",
        "deleteConfirmation": "sei sicuro di voler cancellare questo evento?",
        "deleteDialogTitle": "Elimina evento"
    },
    "multiviewcalendar": {
        "prevView": "Vai alla vista precedente",
        "nextView": "Passa alla visualizzazione successiva"
    },
    "columnMenu": {
        "columnMenuFilterClearButton": "Chiaro",
        "columnMenuFilterSubmitButton": "Filtro",
        "columnMenuFilterTitle": "Filtro",
        "columnMenuSortAscending": "Ordine crescente",
        "columnMenuSortDescending": "Ordine decrescente",
        "columnMenuFilterEqOperator": "È uguale a",
        "columnMenuFilterNotEqOperator": "Non è uguale a",
        "columnMenuFilterIsNullOperator": "È zero",
        "columnMenuFilterIsNotNullOperator": "non è nullo",
        "columnMenuFilterIsEmptyOperator": "È vuoto",
        "columnMenuFilterIsNotEmptyOperator": "Non è vuoto",
        "columnMenuFilterStartsWithOperator": "Inizia con",
        "columnMenuFilterContainsOperator": "contiene",
        "columnMenuFilterNotContainsOperator": "Non contiene",
        "columnMenuFilterEndsWithOperator": "Finisce con",
        "columnMenuFilterGteOperator": "È più grande di O uguale a",
        "columnMenuFilterGtOperator": "È più grande di",
        "columnMenuFilterLteOperator": "È minore o uguale a",
        "columnMenuFilterLtOperator": "È meno di",
        "columnMenuFilterIsTrue": "È vero",
        "columnMenuFilterAfterOrEqualOperator": "È dopo o uguale a",
        "columnMenuFilterAfterOperator": "è dopo",
        "columnMenuFilterBeforeOperator": "è prima",
        "columnMenuFilterBeforeOrEqualOperator": "È prima o uguale a",
        "columnMenuFilterAndLogic": "e",
        "columnMenuFilterOrLogic": "o"
    },
    "pivotgrid": {
        "fieldMenuReset": "Ripristina",
        "fieldMenuApply": "Applicare",
        "configuratorCancel": "Annulla",
        "configuratorApply": "Applicare",
        "configuratorTitle": "Impostazioni",
        "configuratorEditorSearchTitle": "Campi",
        "configuratorEditorSearchPlaceholder": "Ricerca...",
        "configuratorColumnsTitle": "colonne",
        "configuratorRowsTitle": "righe",
        "configuratorMeasuresTitle": "I valori",
        "configuratorButtonLabel": "Cambia impostazioni",
        "configuratorMissingFields": "Seleziona alcuni campi per iniziare la configurazione"
    }
}

